import React, { useEffect,useState, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Projects.css"
const Projects = () => {
  const containerRef = useRef(null);
  const panelsRef = useRef([]);
  
  const projects = [
    {
      title: "LateComers Management",
      img: "/Images/Projects/LateComers1.png",
      project: "Automated Management System",
      client: "P.B.S.J. CHAKRAVARTHI",
      duration: "3 months",
      frameworks: "React js, Node js, MongoDB",
      preview: "https://adityauniversity.in/latecomers/login",
      github: "https://github.com/Saichandu03/LateComers-Management-System",
    },
    {
      title: "Matrix AI",
      img: "/Images/Projects/Matrix.jpg",
      project: "Multi Model AI Interactive Agent",
      client: "SIVA SATTIRAJU",
      duration: "4 months",
      frameworks: "AI Models, React js, Node js, Postgre SQL",
      preview: "http://210.212.210.86:7002/",
      github: "https://github.com/Saichandu03/Matrix-Multimodel-AI-Platform"
    },
    {
      title: "Job Align",
      img: "Images/Projects/JobAlign.png",
      project: "Personal AI-Powered Career Navigator",
      client: "Internal Project",
      duration: "2 months",
      frameworks: "AI API's, React Native, Node js, Mongo DB.",
      preview: "https://github.com/Saichandu03/Job_Align",
      github: "https://github.com/Saichandu03/Job_Align"
    },
    {
      title: "Social-Connect",
      img: "/Images/Projects/SocialConnect.png",
      project: "A Real-Time Social Media App",
      client: "Internal Project",
      duration: "1 month",
      frameworks: "React.js, Express.js, MongoDB, Socket.io",
      preview: "https://social-connect-blush.vercel.app/",
      github: "https://github.com/Saichandu03/Social-Connect"
    },
    {
      title: "Veda Tech Fest",
      img: "/Images/Projects/Veda1.png",
      project: "Technical Fest Organizing Website",
      client: "K.V.SATYANARAYANA",
      duration: "2 months",
      frameworks: "React.js, Express.js, MongoDB",
      preview: "https://adityauniversity.in/veda2024",
      github: "https://github.com/Saichandu03/Veda-Techfest"
    },
    {
      title: "Food Recipe Finder",
      img: "/Images/Projects/RecipeFinder1.png",
      project: "Food Recipe Website",
      client: "Internal Project",
      duration: "1 month",
      frameworks: "HTML, CSS, JavaScript",
      preview: "https://recipe-finder-two-murex.vercel.app/HomePage/RecipeFinder/home.html",
      github: "https://github.com/Saichandu03/Recipe-Finder"
    },
    // {
    //   title: "College Mobile App",
    //   img: "https://www.hammermarketing.com/wp-content/uploads/sites/2/2020/11/react-native_large.jpg",
    //   project: "Mobile Application",
    //   client: "College Project",
    //   duration: "1 month",
    //   frameworks: "React Native, AWS, Node.js",
    //   preview: "https://youtube.com/shorts/3Emi8h5j4Dc?feature=share",
    // },
    // {
    //   title: "Coding Compiler",
    //   img: "https://api-4ixzu4qsgq-uc.a.run.app/gangadhar_jami/projects/compiler.jpg",
    //   project: "Website",
    //   client: "Internal Project",
    //   duration: "1 month",
    //   frameworks: "React Js, AWS, Node.js",
    //   preview: "https://gangadharcodingcompiler.web.app/",
    // },
  ];

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    
    // Clean up existing ScrollTrigger instances
    ScrollTrigger.getAll().forEach(st => st.kill());
    
    const panels = panelsRef.current;
    
    // Create a smooth horizontal scroll effect with precise snapping
    let scrollTween = gsap.to(panels, {
      xPercent: -100 * (panels.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: containerRef.current,
        pin: true,
        scrub: 0.5, // Smaller value for more responsive scrolling
        snap: {
          snapTo: 1 / (panels.length - 1),
          duration: 0.3, // Faster snap
          delay: 0, // No delay for immediate response
          ease: "power2.out" // Smoother easing
        },
        start: "top top",
        end: () => `+=${panels.length * 100}%`,
        invalidateOnRefresh: true // Ensures recalculation on resize
      }
    });
    
    // Add animation for each panel to enhance visual interest
    panels.forEach((panel, i) => {
      // Create scene entrance animations
      ScrollTrigger.create({
        trigger: panel,
        containerAnimation: scrollTween,
        start: "left center",
        end: "right center",
        toggleClass: "project-active",
        onEnter: () => {
          gsap.to(panel.querySelector('.project-content'), {
            scale: 1,
            opacity: 1,
            duration: 0.4
          });
        },
        onLeave: () => {
          gsap.to(panel.querySelector('.project-content'), {
            scale: 0.95,
            opacity: 0.7,
            duration: 0.4
          });
        },
        onEnterBack: () => {
          gsap.to(panel.querySelector('.project-content'), {
            scale: 1,
            opacity: 1,
            duration: 0.4
          });
        },
        onLeaveBack: () => {
          gsap.to(panel.querySelector('.project-content'), {
            scale: 0.95,
            opacity: 0.7,
            duration: 0.4
          });
        }
      });
    });
    
    // Handle resize
    const handleResize = () => {
      ScrollTrigger.refresh(true);
    };
    
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
      ScrollTrigger.getAll().forEach(st => st.kill());
    };
  }, []);

  // Add ref to panel
  const addPanelRef = (el) => {
    if (el && !panelsRef.current.includes(el)) {
      panelsRef.current.push(el);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);


  return (
    <div className="projects-section" >
      <div className="projects-container" ref={containerRef} >
        <div className="projects-wrapper" style={{marginTop : 20}} >
          {projects.map((project, index) => (
            <div 
              key={index} 
              className="project-panel" 
              ref={addPanelRef}
            >
              <div className="project-content" style={{marginTop : "100px"}}>
                <div className="project-image-container">
                  <div className="project-image">
                    <img 
                      src={project.img} 
                      alt={project.title} 
                      loading="lazy" 
                    />
                  </div>
                </div>
                <div className="project-details">
                  <h4 style={{marginTop : -20}}>{project.title}</h4>
                  <ul style={{marginBottom : isMobile && 10}}>
                    <li><span>Project:</span> {project.project}</li>
                    <li><span>Client:</span> {project.client}</li>
                    <li><span>Duration:</span> {project.duration}</li>
                    <li><span>Frameworks:</span> {project.frameworks}</li>
                  </ul>
                  <div className="project-btn-group" style={{display: 'flex', gap: '14px', marginTop: 18}}>
                    <a
                      href={project.preview}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-btn preview-btn"
                      style={{marginBottom: isMobile && 0, display: 'inline-flex', alignItems: 'center'}}
                    >
                      Preview
                      <svg style={{verticalAlign: 'middle', marginLeft: 8}} width="18" height="18" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M432 320c-13.3 0-24 10.7-24 24v104c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V128c0-13.3 10.7-24 24-24h104c13.3 0 24-10.7 24-24s-10.7-24-24-24H88C39.4 56 0 95.4 0 144v304c0 48.6 39.4 88 88 88h296c48.6 0 88-39.4 88-88V344c0-13.3-10.7-24-24-24z" fill="currentColor"/>
                        <path d="M488 0H344c-13.3 0-24 10.7-24 24s10.7 24 24 24h86.1L201.4 277.7c-9.4 9.4-9.4 24.6 0 33.9 4.7 4.7 10.8 7 17 7s12.3-2.3 17-7L464 81.9V168c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24z" fill="currentColor"/>
                      </svg>
                    </a>
                    {project.github && (
                      <a
                        href={project.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-btn github-btn outline"
                        style={{marginBottom: isMobile && 0, display: 'inline-flex', alignItems: 'center'}}
                      >
                        <svg style={{verticalAlign: 'middle', marginRight: 6}} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2C6.48 2 2 6.58 2 12.26c0 4.5 2.87 8.32 6.84 9.67.5.09.68-.22.68-.48 0-.24-.01-.87-.01-1.7-2.78.62-3.37-1.36-3.37-1.36-.45-1.18-1.1-1.5-1.1-1.5-.9-.63.07-.62.07-.62 1 .07 1.53 1.05 1.53 1.05.89 1.56 2.34 1.11 2.91.85.09-.66.35-1.11.63-1.37-2.22-.26-4.56-1.14-4.56-5.07 0-1.12.39-2.03 1.03-2.75-.1-.26-.45-1.3.1-2.7 0 0 .84-.28 2.75 1.05A9.38 9.38 0 0 1 12 6.84c.85.004 1.71.12 2.51.35 1.91-1.33 2.75-1.05 2.75-1.05.55 1.4.2 2.44.1 2.7.64.72 1.03 1.63 1.03 2.75 0 3.94-2.34 4.81-4.57 5.07.36.32.68.94.68 1.9 0 1.37-.01 2.47-.01 2.81 0 .27.18.58.69.48A10.01 10.01 0 0 0 22 12.26C22 6.58 17.52 2 12 2z" fill="currentColor"/>
                        </svg>
                        GitHub
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;